{
  "approvals": {
    "byDelegation": "بالتفويض من {{name}} حتى {{until}}"
  }
}
